module.exports = __webpack_public_path__ + "img/diagnostic2.8865b1fb.jpg";